"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
var yup = __importStar(require("yup"));
yup.setLocale({
    string: {
        email: "Enter an email address in the correct format (for example, name@example.com)",
    },
});
function validate(schema, val, paths) {
    return __awaiter(this, void 0, void 0, function () {
        var res, list, _i, list_1, p, ex_1, errs, _a, _b, e, current, parts, i, p_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    res = {};
                    if (typeof paths == "string") {
                        list = [paths];
                    }
                    else if (paths) {
                        list = paths;
                    }
                    else
                        list = [""];
                    _i = 0, list_1 = list;
                    _c.label = 1;
                case 1:
                    if (!(_i < list_1.length)) return [3, 9];
                    p = list_1[_i];
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 7, , 8]);
                    if (!(p != "")) return [3, 4];
                    return [4, schema.validateAt(p, val, { abortEarly: false })];
                case 3:
                    _c.sent();
                    return [3, 6];
                case 4: return [4, schema.validate(val, { abortEarly: false })];
                case 5:
                    _c.sent();
                    _c.label = 6;
                case 6: return [3, 8];
                case 7:
                    ex_1 = _c.sent();
                    errs = ex_1;
                    if (!errs.inner) {
                        throw ex_1;
                    }
                    for (_a = 0, _b = errs.inner; _a < _b.length; _a++) {
                        e = _b[_a];
                        if (!e.path || e.path.length == 0) {
                            continue;
                        }
                        current = res;
                        parts = e.path.split(".");
                        for (i = 0; i < parts.length; i++) {
                            p_1 = parts[i];
                            if (i == parts.length - 1) {
                                current[p_1] = e.message;
                            }
                            else {
                                if (!(p_1 in res)) {
                                    current[p_1] = {};
                                }
                                current = current[p_1];
                            }
                        }
                    }
                    ;
                    return [3, 8];
                case 8:
                    _i++;
                    return [3, 1];
                case 9: return [2, [res, val]];
            }
        });
    });
}
exports.validate = validate;
//# sourceMappingURL=Validate.js.map